import axios from 'axios';

const BASE_API = process.env.REACT_APP_API_URL || 'http://localhost:3000/api/v1';

/**
 * Get shifts for a specific restaurant and date
 * @param {number} restaurantId - The restaurant ID
 * @param {string} date - The date in YYYY-MM-DD format
 * @returns {Promise<{ shifts: Array }>}
 */
export const getShiftsForDate = async (restaurantId, date) => {
  try {
    const response = await axios.get(
      `${BASE_API}/public/shifts/restaurant/${restaurantId}/date/${date}`
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching shifts:', error);
    return { shifts: [] };
  }
};

/**
 * Get a single shift by ID (used when pre-selecting an event shift via widget link).
 * @param {number|string} id
 * @returns {Promise<Object|null>}
 */
export const getShiftById = async (id) => {
  try {
    const response = await axios.get(`${BASE_API}/public/shifts/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching shift by id:', error);
    return null;
  }
};

/**
 * Get slot availability for a shift on a specific date
 * @param {number} shiftId - The shift ID
 * @param {string} date - The date in YYYY-MM-DD format
 * @returns {Promise<{ shiftId: number, date: string, allowOverbooking: boolean, slots: Array<{ time: string, maxCapacity: number|null, bookedGuests: number, remainingCapacity: number|null, isBlocked: boolean }> }>}
 */
export const getSlotAvailability = async (shiftId, date) => {
  try {
    const response = await axios.get(
      `${BASE_API}/public/shifts/${shiftId}/availability/${date}`
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching slot availability:', error);
    return { shiftId, date, allowOverbooking: false, slots: [] };
  }
};
